// extracted by mini-css-extract-plugin
export default {"button":"Button_button__KXFVC","button_spinner":"Button_button_spinner__15oDT","button_contained":"Button_button_contained__geRFy","button_outline":"Button_button_outline__+bqCB"};